import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Slide in on next frame
    requestAnimationFrame(() => {
      this.element.classList.remove('translate-x-full')
      this.element.classList.add('translate-x-0')
    })

    this.timer = setTimeout(() => this.dismiss(), 5000)
  }

  close() {
    clearTimeout(this.timer)
    this.dismiss()
  }

  dismiss() {
    this.element.classList.remove('translate-x-0')
    this.element.classList.add('translate-x-full')
    setTimeout(() => this.element.remove(), 300)
  }
}
